var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStopSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "oglninatta",
    cx: 7.598,
    cy: 7.598,
    r: 7.598
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-689 -323) translate(573 249) translate(119.902 78.402)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeWidth: 7,
    xlinkHref: "#oglninatta"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#BCBCBC",
    strokeWidth: 2,
    xlinkHref: "#oglninatta"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#BCBCBC",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M2.598 12.546L12.098 3.046",
    transform: "translate(-689 -323) translate(573 249) translate(119.902 78.402)"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopSign);
export default __webpack_public_path__ + "static/media/stop-sign.1744971a5fa0424036cd1ee5a18a84a7.svg";
export { ForwardRef as ReactComponent };